/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PointsetCreationByMarker } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class PointsetBuilderClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags PointsetBuilder
   * @summary Создание набора точек по имени маркера.
   * @request POST:/geology/pointset_builder/project/{projectId}/create_from_marker
   * @secure
   */
  pointsetBuilderCreatePointsetByMarkerName = (
    projectId: string,
    data: PointsetCreationByMarker,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/geology/pointset_builder/project/${projectId}/create_from_marker`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
